import { render } from "./LivenessCheck.vue?vue&type=template&id=3d77b0c3"
import script from "./LivenessCheck.vue?vue&type=script&lang=js"
export * from "./LivenessCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__